export const Size = {
  XS: 'xs' as 'xs',
  DEFAULT: 'default' as 'default',
  SM: 'sm' as 'sm',
  LG: 'lg' as 'lg',
  XL: 'xl' as 'xl'
};

export type Size = typeof Size[keyof typeof Size];
